export const CategoriasCompras = [
	{label: "Infraestructura Tecnológica.", value: "Infraestructura Tecnológica."},
	{label: "Software y Licencias.", value: "Software y Licencias."},
	{label: "Recursos Humanos.", value: "Recursos Humanos."},
	{label: "Servicios Profesionales y Administrativos.", value: "Servicios Profesionales y Administrativos."},
	{label: "Marketing y Publicidad Propia.", value: "Marketing y Publicidad Propia."},
	{label: "Comunicaciones.", value: "Comunicaciones."},
	{label: "Proyectos para Clientes.", value: "Proyectos para Clientes."},
	{label: "Logística y Movilidad.", value: "Logística y Movilidad."},
	{label: "Otros Gastos Operativos.", value: "Otros Gastos Operativos."},
	{label: "Inversiones o Activos Fijos.", value: "Inversiones o Activos Fijos."},
]

export const SubcategoriasCompras = [

	// Infraestructura tecnológica
	{category: "Infraestructura Tecnológica.", value: "Hosting.", label: "Hosting."},
	{category: "Infraestructura Tecnológica.", value: "Dominios.", label: "Dominios."},
	{category: "Infraestructura Tecnológica.", value: "Servidores VPS o Servicios cloud.", label: "Servidores VPS o Servicios cloud."},
	{category: "Infraestructura Tecnológica.", value: "Bases de datos.", label: "Bases de datos."},
	{category: "Infraestructura Tecnológica.", value: "Backups y recuperación.", label: "Backups y recuperación."},
	{category: "Infraestructura Tecnológica.", value: "Seguridad y firewall", label: "Seguridad y firewall"},

	// Spftware y licencias
	{category: "Software y Licencias.", value: "Diseño gráfico.", label: "Diseño gráfico."},
	{category: "Software y Licencias.", value: "UX/UI y prototipado.", label: "UX/UI y prototipado."},
	{category: "Software y Licencias.", value: "Desarrollo web.", label: "Desarrollo web."},
	{category: "Software y Licencias.", value: "Herramientas de Productividad.", label: "Herramientas de Productividad."},
	{category: "Software y Licencias.", value: "Almacenamiento y archivos.", label: "Almacenamiento y archivos."},
	{category: "Software y Licencias.", value: "Inteligencia artificial.", label: "Inteligencia artificial."},
	{category: "Software y Licencias.", value: "CRM / ERP.", label: "CRM / ERP."},
	{category: "Software y Licencias.", value: "Plataformas de integración o Automatizaciones.", label: "Plataformas de integración o Automatizaciones."},
	{category: "Software y Licencias.", value: "Email marketing.", label: "Email marketing."},
	{category: "Software y Licencias.", value: "Licencias para clientes.", label: "Licencias para clientes."},
	{category: "Software y Licencias.", value: "Herramientas de analítica.", label: "Herramientas de analítica."},
	{category: "Software y Licencias.", value: "Plugins, Themes y extensiones.", label: "Plugins, Themes y extensiones."},

	// Recursos humanos
	{category: "Recursos Humanos.", value: "Sueldos y honorarios.", label: "Sueldos y honorarios."},
	{category: "Recursos Humanos.", value: "Freelancers Agencia.", label: "Freelancers Agencia."},
	{category: "Recursos Humanos.", value: "Gratificaciones", label: "Gratificaciones"},
	{category: "Recursos Humanos.", value: "AFP / ONP", label: "AFP / ONP"},
	{category: "Recursos Humanos.", value: "Seguros de Salud", label: "Seguros de Salud"},
	{category: "Recursos Humanos.", value: "Cursos y capacitaciones.", label: "Cursos y capacitaciones."},
	{category: "Recursos Humanos.", value: "Bonos e incentivos.", label: "Bonos e incentivos."},
	{category: "Recursos Humanos.", value: "Comidas y refrigerios.", label: "Comidas y refrigerios."},
	{category: "Recursos Humanos.", value: "Equipamiento personal.", label: "Equipamiento personal."},
	{category: "Recursos Humanos.", value: "Uniformes y branding interno.", label: "Uniformes y branding interno."},
	{category: "Recursos Humanos.", value: "Bienestar o ambiente laboral", label: "Bienestar o ambiente laboral"},
	{category: "Recursos Humanos.", value: "Seguros personales", label: "Seguros personales"},

	// Servicios profesionales y administrativos
	{category: "Servicios Profesionales y Administrativos.", value: "Contabilidad.", label: "Contabilidad."},
	{category: "Servicios Profesionales y Administrativos.", value: "Asesoría legal.", label: "Asesoría legal."},
	{category: "Servicios Profesionales y Administrativos.", value: "Certificaciones empresariales.", label: "Certificaciones empresariales."},
	{category: "Servicios Profesionales y Administrativos.", value: "Asesoría externa.", label: "Asesoría externa."},
	{category: "Servicios Profesionales y Administrativos.", value: "Servicios fiscales o tributarios.", label: "Servicios fiscales o tributarios."},
	{category: "Servicios Profesionales y Administrativos.", value: "Auditorías", label: "Auditorías"},

	// Marketing y publicidad propia
	{category: "Marketing y Publicidad Propia.", value: "Campañas digitales.", label: "Campañas digitales."},
	{category: "Marketing y Publicidad Propia.", value: "Patrocinios", label: "Patrocinios"},
	{category: "Marketing y Publicidad Propia.", value: "Eventos y activaciones.", label: "Eventos y activaciones."},
	{category: "Marketing y Publicidad Propia.", value: "Influencers.", label: "Influencers."},

	// Comunicaciones
	{category: "Comunicaciones.", value: "Telefonía móvil.", label: "Telefonía móvil."},
	{category: "Comunicaciones.", value: "Telefonía fija.", label: "Telefonía fija."},
	{category: "Comunicaciones.", value: "Internet.", label: "Internet."},
	{category: "Comunicaciones.", value: "Mensajería SMS / API de comunicación", label: "Mensajería SMS / API de comunicación"},

	// Proyectos para clientes
	{category: "Proyectos para Clientes.", value: "Hosting cliente.", label: "Hosting cliente."},
	{category: "Proyectos para Clientes.", value: "Dominio cliente.", label: "Dominio cliente."},
	{category: "Proyectos para Clientes.", value: "Plugins, Themes y extensiones cliente", label: "Plugins, Themes y extensiones cliente"},
	{category: "Proyectos para Clientes.", value: "Publicidad para cliente.", label: "Publicidad para cliente."},
	{category: "Proyectos para Clientes.", value: "Freelancers para Clientes", label: "Freelancers para Clientes"},

	// Logística y movilidad
	{category: "Logística y Movilidad.", value: "Combustible.", label: "Combustible."},
	{category: "Logística y Movilidad.", value: "Delivery y envíos.", label: "Delivery y envíos."},
	{category: "Logística y Movilidad.", value: "Alquileres temporales.", label: "Alquileres temporales."},
	{category: "Logística y Movilidad.", value: "Viajes por trabajo.", label: "Viajes por trabajo."},
	{category: "Logística y Movilidad.", value: "Viáticos.", label: "Viáticos."},

	// Otros gastos operativos
	{category: "Otros Gastos Operativos.", value: "Papelería e impresión.", label: "Papelería e impresión."},
	{category: "Otros Gastos Operativos.", value: "Comisiones bancarias.", label: "Comisiones bancarias."},
	{category: "Otros Gastos Operativos.", value: "Comisiones de apps de pago.", label: "Comisiones de apps de pago."},
	{category: "Otros Gastos Operativos.", value: "Regalos corporativos.", label: "Regalos corporativos."},

	// Inversiones o activos fijos
	{category: "Inversiones o Activos Fijos.", value: "Equipos de cómputo.", label: "Equipos de cómputo."},
	{category: "Inversiones o Activos Fijos.", value: "Cámaras y equipo audiovisual.", label: "Cámaras y equipo audiovisual."},
	{category: "Inversiones o Activos Fijos.", value: "Mobiliario de oficina.", label: "Mobiliario de oficina."},
	{category: "Inversiones o Activos Fijos.", value: "Licencias perpetuas.", label: "Licencias perpetuas."},
	{category: "Inversiones o Activos Fijos.", value: "Adecuación de oficina.", label: "Adecuación de oficina."},
	{category: "Inversiones o Activos Fijos.", value: "Software de alto valor.", label: "Software de alto valor."},
]

